// Pure, unit-tested helpers for the Dashboard home and the detail-panel
// collapse it introduced — extracted from App / SplitPage / CanvasMenu /
// CanvasesBody so the logic is covered by dashboardHome.test.js instead of
// living inline across React components.

// Built-ins first (their shipped order), then the tenant's own canvases. The
// order the Dashboard sidebar list, its tab strip, and the scope.canvases lens
// all render in.
export function orderCanvases(canvases = []) {
    const builtins = canvases.filter((c) => c.builtin);
    const user = canvases.filter((c) => !c.builtin);
    return [...builtins, ...user];
}

// A Dashboard home tab is { kind, id }, and a canvas tab's id IS its slug, so
// renaming a canvas strands its tab on a slug nothing resolves. The tab follows
// the rename; one already open on the new id becomes a duplicate of it and is
// dropped. Returns the original array when nothing matches, so a caller passing
// this to setState does not re-render for a canvas with no home tab open.
export function renameHomeTab(tabs = [], kind, fromId, toId) {
    if (!fromId || !toId || fromId === toId) return tabs;
    if (!tabs.some((t) => t.kind === kind && t.id === fromId)) return tabs;
    const followed = tabs.map((t) =>
        (t.kind === kind && t.id === fromId ? { ...t, id: toId } : t));
    return followed.filter((t, i) =>
        followed.findIndex((other) => other.kind === t.kind && other.id === t.id) === i);
}

// Drop the home tab for an item that stopped existing. Same identity-preserving
// contract as renameHomeTab.
export function removeHomeTab(tabs = [], kind, id) {
    if (!id || !tabs.some((t) => t.kind === kind && t.id === id)) return tabs;
    return tabs.filter((t) => !(t.kind === kind && t.id === id));
}

// Initial collapse of a SplitPage detail panel from the persisted ?dcol param.
// An explicit value wins ("collapsed" / "open"); absent falls back to the
// page's default.
export function resolveDetailCollapsed(dcolParam, defaultCollapsed) {
    if (dcolParam === "collapsed") return true;
    if (dcolParam === "open") return false;
    return !!defaultCollapsed;
}

// The ?dcol value to persist: only the NON-default state, so a page sitting at
// its default keeps a clean URL. Returns null to clear the param.
export function detailCollapseParam(collapsed, defaultCollapsed) {
    if (!!collapsed === !!defaultCollapsed) return null;
    return collapsed ? "collapsed" : "open";
}
